import { t } from "i18next"

export function getBasePage(): any {
    return {
        "page": {
            "body": {
                "container": {
                    "style": {
                        "background-color": "#f9f9f9"
                    }
                },
                "content": {
                    "computedStyle": {
                        "linkColor": "#0068A5",
                        "messageBackgroundColor": "transparent",
                        "messageWidth": "1024px"
                    },
                    "style": {
                        "color": "#000000",
                        "font-family": "Montserrat, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif"
                    }
                },
                "type": "mailup-bee-page-properties",
                "webFonts": []
            },
            "description": "",
            "rows": [
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "89dbccdf-8f23-44d8-9472-ee45a6d7184d"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "b74071ac-95b9-4038-a1f1-dc3a7128836f"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#bf8abf",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-1-columns-12",
                    "uuid": "82093e56-0812-4174-83c8-20e80bdd6dfb"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "left fixedwidth",
                                            "width": "180px"
                                        },
                                        "image": {
                                            "alt": "Alternate text",
                                            "height": "47px",
                                            "href": "",
                                            "prefix": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2476/Book_logo_2.png",
                                            "target": "_self",
                                            "width": "203px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "15px",
                                            "padding-right": "0px",
                                            "padding-top": "5px",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "067c3f72-a2b1-474e-a3a5-c7619299f3ed"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "54231a86-ecf7-44b3-95ce-ed682472c429"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hamburger": {
                                                "backgroundColor": "#ffffff",
                                                "foregroundColor": "#bf8abf",
                                                "iconSize": "36px",
                                                "iconType": "normal",
                                                "mobile": true
                                            },
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false,
                                            "layout": "horizontal",
                                            "linkColor": "#ffffff",
                                            "menuItemsSpacing": {
                                                "padding-bottom": "5px",
                                                "padding-left": "25px",
                                                "padding-right": "25px",
                                                "padding-top": "5px"
                                            },
                                            "separator": "|"
                                        },
                                        "menuItemsList": {
                                            "items": [
                                                {
                                                    "link": {
                                                        "href": "#",
                                                        "target": "_self",
                                                        "title": ""
                                                    },
                                                    "text": t("page-default-menu-item") + " 1"
                                                },
                                                {
                                                    "link": {
                                                        "href": "#",
                                                        "target": "_self",
                                                        "title": ""
                                                    },
                                                    "text": t("page-default-menu-item") + " 2"
                                                },
                                                {
                                                    "link": {
                                                        "href": "#",
                                                        "target": "_self",
                                                        "title": ""
                                                    },
                                                    "text": t("page-default-menu-item") + " 3"
                                                },
                                                {
                                                    "link": {
                                                        "href": "",
                                                        "target": "_self",
                                                        "title": ""
                                                    },
                                                    "text": t("page-default-menu-item") + " 4"
                                                }
                                            ]
                                        },
                                        "style": {
                                            "color": "#ffffff",
                                            "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                            "font-size": "14px",
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "10px",
                                            "text-align": "right"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-menu",
                                    "uuid": "011764ae-2393-4edd-9d9a-e2ae36386b3f"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "10px",
                                "padding-top": "5px"
                            },
                            "uuid": "bade92f9-417d-4519-85fb-2f6d85d1660a"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#bf8abf",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": false,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-2-columns-6-6",
                    "uuid": "7ec9cad2-75ab-4a0a-a4b8-444540495fa6"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "5px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "c889f8fc-33d8-4ff7-b09d-94c650e64bb3"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "9a2d270e-c254-400c-8ed0-6f29461cba57"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#bf8abf",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "one-column-empty",
                    "uuid": "02c8a2ac-3ce1-4709-bf21-061b3c419f2e"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "75px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "f258cd70-e2cd-4e13-a380-430edfb595f5"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><strong><span>" + t("page-default-content-title") + "</span></strong></p>",
                                            "style": {
                                                "color": "#ffffff",
                                                "font-family": "inherit",
                                                "font-size": "34px",
                                                "line-height": "120%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "20px",
                                            "padding-right": "20px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "17fb6491-5f40-497b-8c8b-934d4e397eb1"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span>" + t("page-default-content-description") + "</span></p>",
                                            "style": {
                                                "color": "#ffffff",
                                                "font-family": "inherit",
                                                "font-size": "24px",
                                                "line-height": "180%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "20px",
                                            "padding-right": "20px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "32781700-72c8-4a74-836d-82cc45b97da1"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span>James Brown</span></p>",
                                            "style": {
                                                "color": "#000000",
                                                "font-family": "inherit",
                                                "font-size": "17px",
                                                "line-height": "150%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "25px",
                                            "padding-left": "20px",
                                            "padding-right": "20px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "e51fa8fc-2e2b-4acd-9787-45218d20c798"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"\" data-mce-style=\"\"><p style=\"word-break:break-word;\" data-mce-style=\"word-break:break-word;\"><strong>" + t("page-default-button-label") + "</strong></p></div>",
                                            "style": {
                                                "background-color": "#ffffff",
                                                "border-bottom": "0px solid transparent",
                                                "border-left": "0px solid transparent",
                                                "border-radius": "4px",
                                                "border-right": "0px solid transparent",
                                                "border-top": "0px solid transparent",
                                                "color": "#bf8abf",
                                                "direction": "ltr",
                                                "font-family": "inherit",
                                                "font-size": "16px",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "50px",
                                                "padding-right": "50px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            },
                                            "target": "_self"
                                        },
                                        "computedStyle": {
                                            "height": 42,
                                            "hideContentOnMobile": false,
                                            "width": 189
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "20px",
                                            "padding-right": "20px",
                                            "padding-top": "10px",
                                            "text-align": "left"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "7b3af2c6-9e8a-495e-83e8-890d3582169c"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "54231a86-ecf7-44b3-95ce-ed682472c429"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth fullwidthOnMobile",
                                            "width": "648px"
                                        },
                                        "image": {
                                            "alt": "Alternate text",
                                            "height": "1260px",
                                            "href": "",
                                            "prefix": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2476/Book_2__1.png",
                                            "target": "_self",
                                            "width": "1280px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "054d3232-68a2-4265-8b55-3000bcbec203"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "10px",
                                "padding-top": "5px"
                            },
                            "uuid": "bade92f9-417d-4519-85fb-2f6d85d1660a"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#bf8abf",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": false,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-2-columns-6-6",
                    "uuid": "d4324ba5-e5b7-463a-b92d-bda87651456d"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "35px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "d3c0e9e9-e32b-408a-8fbf-efb2c10d7797"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><strong><span>" + t("page-default-content-title") + "</span></strong></p>",
                                            "style": {
                                                "color": "#34495e",
                                                "font-family": "inherit",
                                                "font-size": "26px",
                                                "line-height": "120%",
                                                "text-align": "center"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "35px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "30px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "f4a0b3c9-a34e-4bf9-ac1a-1770c4c4331c"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "25px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "b47af6d7-db9b-4f7b-9e56-1030da94ea87"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "ca2c2714-6aa2-40f4-97ed-c24e1a0e18dc"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-1-columns-12",
                    "uuid": "0c1b906e-0c74-43fc-aac8-628afac53b14"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "align": "left",
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth fullwidthOnMobile",
                                            "width": "648px"
                                        },
                                        "image": {
                                            "alt": "Alternate text",
                                            "height": "350px",
                                            "href": "#",
                                            "prefix": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2476/book_1.png",
                                            "target": "_self",
                                            "width": "395px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "e5533b3d-6bb2-4442-b14e-ba978df370d9"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "0699bcc0-8cf0-47be-8ff9-8b5b98d3fe6a"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "align": "left",
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "left",
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": true
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "5px solid transparent",
                                                "height": "30px",
                                                "width": "15%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "15px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "280b0848-7754-416f-ab4d-9eaff118f08d"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span style=\"background-color:#7bcbeb;\"><strong><span style=\"background-color:#7bcbeb;\"> </span></strong></span><span style=\"background-color:#7bcbeb;\"><strong><span style=\"background-color:#7bcbeb;\">" + t("page-default-content-title") + " </span></strong></span></p>",
                                            "style": {
                                                "color": "#ffffff",
                                                "font-family": "inherit",
                                                "font-size": "24px",
                                                "line-height": "200%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "20px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "f23ae472-475f-41fc-8d50-863750595364"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><strong><span>" + t("page-default-content-title") + "</span></strong></p>",
                                            "style": {
                                                "color": "#34495e",
                                                "font-family": "inherit",
                                                "font-size": "24px",
                                                "line-height": "200%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "20px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "b76e8650-69bc-4b3e-8f08-3256afc1bd95"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span>" + t("page-default-content-description") + "</span></p>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "font-size": "20px",
                                                "line-height": "180%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "20px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "78ca4109-08c8-45f5-ac18-c7fbb339fc30"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"\" data-mce-style=\"\"><p style=\"word-break:break-word;\" data-mce-style=\"word-break:break-word;\"><strong>" + t("page-default-button-label") + "</strong></p></div>",
                                            "style": {
                                                "background-color": "#7bcbeb",
                                                "border-bottom": "0px solid transparent",
                                                "border-left": "0px solid transparent",
                                                "border-radius": "4px",
                                                "border-right": "0px solid transparent",
                                                "border-top": "0px solid transparent",
                                                "color": "#ffffff",
                                                "direction": "ltr",
                                                "font-family": "inherit",
                                                "font-size": "16px",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "50px",
                                                "padding-right": "50px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            },
                                            "target": "_self"
                                        },
                                        "computedStyle": {
                                            "height": 42,
                                            "hideContentOnMobile": false,
                                            "width": 189
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "20px",
                                            "padding-right": "20px",
                                            "padding-top": "10px",
                                            "text-align": "left"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "143b1675-b91d-41f6-87c0-404dd787d473"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "5349bb10-f417-48e3-851c-d355e315163a"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "linkColor": "#000000",
                            "messageBackgroundColor": "#000000",
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "metadata": {
                        "category": 477754,
                        "dateCreated": "2020-06-06T15:51:32.334702Z",
                        "dateModified": "2020-06-06T15:51:33.913677Z",
                        "description": "Test Description",
                        "idParent": null,
                        "name": "Image with tex",
                        "slug": "image-with-tex",
                        "uuid": "a344b496-fb92-489b-a91c-99391a75bb38"
                    },
                    "synced": false,
                    "type": "row-2-columns-6-6",
                    "uuid": "724571c0-64b7-467d-b140-afc2528c1c9b"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "f2c44c97-95a6-4909-be28-4a5247ab572d"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "aa6bc113-78c7-4f04-a93e-fb23a58207ae"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-1-columns-12",
                    "uuid": "9fe67857-d2aa-48a6-ba20-ccdc80dc8cc0"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "5224f457-be93-47f9-9558-c79bcc7a7004"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><strong><span>" + t("page-default-content-title") + "</span></strong></p>",
                                            "style": {
                                                "color": "#34495e",
                                                "font-family": "inherit",
                                                "font-size": "26px",
                                                "line-height": "120%",
                                                "text-align": "center"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "35px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "30px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "26302397-def7-41f9-bba7-dc92a61dcc43"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "15px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "c65ac3dc-c6a3-49f9-9494-3e3c16ed7031"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span><strong>" + t("page-default-content-description") + "</strong></span></p>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "font-size": "15px",
                                                "line-height": "180%",
                                                "text-align": "center"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "40px",
                                            "padding-right": "40px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "5c488cbb-2da4-4e3c-b2e2-779aecad4f2b"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "45px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "767d3081-48b5-4d54-b678-5ca60e9b35d5"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "82bc0250-2da8-4362-a90b-ed8a3af52fad"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "aa6bc113-78c7-4f04-a93e-fb23a58207ae"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#f9f9f9",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "#f9f9f9",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-1-columns-12",
                    "uuid": "55a9be15-8eae-49d2-a020-bc6af9606c33"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "50b342de-9e62-43c0-8c04-6fcfedac7d06"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "aa6bc113-78c7-4f04-a93e-fb23a58207ae"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-1-columns-12",
                    "uuid": "e3f9dcb5-774a-41b8-b5a6-6d4e5d5b21ae"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth fullwidthOnMobile",
                                            "width": "684px"
                                        },
                                        "image": {
                                            "alt": "Alternate text",
                                            "height": "350px",
                                            "href": "",
                                            "prefix": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2476/book_2.png",
                                            "target": "_self",
                                            "width": "395px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "89ffeebe-2367-4d73-8c12-33714f8e79c2"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "567a29e8-fe65-43c7-8d03-a3a8a1456dd6"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span><strong>" + t("page-default-content-title") + " </strong></span></p>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "font-size": "22px",
                                                "line-height": "180%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "20px",
                                            "padding-right": "40px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "bdf09adf-58b0-4945-bc97-cf1638973ec2"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center",
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false
                                        },
                                        "form": {
                                            "structure": {
                                                "attributes": {
                                                    "accept-charset": "UTF-8",
                                                    "action": "",
                                                    "autocomplete": "on",
                                                    "enctype": "multipart/form-data",
                                                    "method": "post",
                                                    "novalidate": false,
                                                    "target": "_self"
                                                },
                                                "description": "",
                                                "fields": {
                                                    "email": {
                                                        "attributes": {
                                                            "required": true
                                                        },
                                                        "canBeModified": false,
                                                        "canBeRemovedFromLayout": false,
                                                        "label": t("general-email"),
                                                        "options": null,
                                                        "removeFromLayout": false,
                                                        "type": "email"
                                                    },
                                                    "permission_checkbox": {
                                                        "attributes": {
                                                            "required": true
                                                        },
                                                        "canBeModified": false,
                                                        "canBeRemovedFromLayout": true,
                                                        "label": t("bee-editor-permission-checkbox-label"),
                                                        "removeFromLayout": true,
                                                        "type": "checkbox"
                                                    },
                                                    "submit_button": {
                                                        "attributes": {
                                                            "name": "submit_button",
                                                            "value": t("general-submit")
                                                        },
                                                        "canBeModified": true,
                                                        "canBeRemovedFromLayout": false,
                                                        "options": null,
                                                        "removeFromLayout": false,
                                                        "type": "submit"
                                                    },
                                                },
                                                "layout": [
                                                    [
                                                        "email"
                                                    ],
                                                    [
                                                        "permission_checkbox"
                                                    ],
                                                    [
                                                        "submit_button"
                                                    ]
                                                ],
                                                "title": ""
                                            },
                                            "style": {
                                                "buttons": {
                                                    "backgroundColor": "#3AAEE0",
                                                    "border-bottom": "0px solid transparent",
                                                    "border-left": "0px solid transparent",
                                                    "border-radius": "4px",
                                                    "border-right": "0px solid transparent",
                                                    "border-top": "0px solid transparent",
                                                    "color": "#ffffff",
                                                    "line-height": "200%",
                                                    "max-width": "100%",
                                                    "outer": {
                                                        "display": "block",
                                                        "flexGrow": 1,
                                                        "padding-buttom": "0px",
                                                        "padding-left": "0px",
                                                        "padding-right": "0px",
                                                        "padding-top": "0px"
                                                    },
                                                    "padding-bottom": "5px",
                                                    "padding-left": "20px",
                                                    "padding-right": "20px",
                                                    "padding-top": "5px",
                                                    "text-align": "center",
                                                    "width": "100%"
                                                },
                                                "fields": {
                                                    "backgroundColor": "#ffffff",
                                                    "border-bottom": "1px solid #DFDFDF",
                                                    "border-left": "1px solid #DFDFDF",
                                                    "border-radius": "4px",
                                                    "border-right": "1px solid #DFDFDF",
                                                    "border-top": "1px solid #DFDFDF",
                                                    "color": "#000000",
                                                    "outlineColor": "#3AAEE0",
                                                    "padding-bottom": "5px",
                                                    "padding-left": "5px",
                                                    "padding-right": "5px",
                                                    "padding-top": "5px"
                                                },
                                                "labels": {
                                                    "color": "#000000",
                                                    "font-style": "",
                                                    "font-weight": "",
                                                    "label-position": "top",
                                                    "line-height": "200%",
                                                    "text-align": "left"
                                                }
                                            }
                                        },
                                        "style": {
                                            "background-color": "transparent",
                                            "font-family": "inherit",
                                            "font-size": "16px",
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-form",
                                    "uuid": "612787df-eb6e-4ecc-a17b-b7e75b18718f"
                                }
                            ],
                            "style": {
                                "background-color": "#ffffff",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "20px",
                                "padding-left": "25px",
                                "padding-right": "15px",
                                "padding-top": "20px"
                            },
                            "uuid": "98b443e9-0c18-4341-8bbb-1f2238f475b7"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-2-columns-6-6",
                    "uuid": "4c9db11b-8143-4347-9e01-87a9c75a5d13"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "f5d2c76d-7c8d-4d11-bde2-789781b05038"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "aa6bc113-78c7-4f04-a93e-fb23a58207ae"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-1-columns-12",
                    "uuid": "f6e7b425-b970-452c-afce-fb2cb1e99aca"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "af83a7e9-455e-4eea-8440-787350cc7328"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><strong><span>" + t("page-default-content-title") + "</span></strong></p>",
                                            "style": {
                                                "color": "#34495e",
                                                "font-family": "inherit",
                                                "font-size": "26px",
                                                "line-height": "120%",
                                                "text-align": "center"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "35px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "30px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "871a46d7-1e62-497a-ad23-fff49cbef155"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "8e5799ce-f066-4071-8a35-e1b16d981746"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span><strong>" + t("page-default-content-description") + "</strong></span></p>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "font-size": "20px",
                                                "line-height": "180%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "40px",
                                            "padding-right": "40px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "df887388-e08c-4f3f-a61b-439a958b6f74"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "7a8526ca-2581-4cf7-b8c7-2d8c6f196fea"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "46d1bee7-8498-4384-bba8-f7364a3612b5"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "aa6bc113-78c7-4f04-a93e-fb23a58207ae"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#f9f9f9",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "#f9f9f9",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-1-columns-12",
                    "uuid": "84ec23d0-4a05-49ef-93bc-d9afa7aed4ac"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "7f405cd4-2f9c-49fa-8a9a-537a1f19c636"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "aa6bc113-78c7-4f04-a93e-fb23a58207ae"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-1-columns-12",
                    "uuid": "c202c8df-071f-4e45-b081-0450fc38f1ba"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "align": "left",
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "left",
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": true
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "5px solid transparent",
                                                "height": "30px",
                                                "width": "15%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "15px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "b6c0afdb-ea61-4051-b67b-4d7e527b9044"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span style=\"background-color:#dc6d5b;\"><span><strong><span style=\"background-color:#dc6d5b;\"> </span></strong></span><span><strong><span style=\"background-color:#dc6d5b;\">" + t("page-default-content-title") + " </span></strong></span></span></p>",
                                            "style": {
                                                "color": "#ffffff",
                                                "font-family": "inherit",
                                                "font-size": "24px",
                                                "line-height": "200%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "20px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "bb937734-24e3-43a0-9591-eeed813d0d2b"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span style=\"background-color:#ffffff;\"><strong><span style=\"background-color:#ffffff;\">" + t("page-default-content-title") + "</span></strong></span></p>",
                                            "style": {
                                                "color": "#34495e",
                                                "font-family": "inherit",
                                                "font-size": "24px",
                                                "line-height": "200%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "20px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "c9eeff0c-2852-4cff-bf4b-0ba1c9a71f91"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span>" + t("page-default-content-description") + "</span></p>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "font-size": "20px",
                                                "line-height": "180%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "20px",
                                            "padding-right": "20px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "46a70496-a2f5-44e7-adb9-eb88ca67a3e3"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "38118a8b-05de-4953-9c32-c65b9ec43a16"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "align": "left",
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth fullwidthOnMobile",
                                            "width": "720px"
                                        },
                                        "image": {
                                            "alt": "I'm an image",
                                            "height": "350px",
                                            "href": "",
                                            "prefix": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2476/right_side_book.png",
                                            "target": "_self",
                                            "width": "395px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "e1255332-1624-4564-bd70-5fd0d5276f12"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "189174e6-bf6e-412b-8063-31ac93b48caa"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "linkColor": "#000000",
                            "messageBackgroundColor": "#000000",
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "metadata": {
                        "category": 477754,
                        "dateCreated": "2020-06-06T15:51:42.232412Z",
                        "dateModified": "2020-06-06T15:51:43.560149Z",
                        "description": "Test Description",
                        "idParent": null,
                        "name": "image text 2",
                        "slug": "image-text-2",
                        "uuid": "72fbf0fb-2974-41df-954c-1b6569cb0e2f"
                    },
                    "synced": false,
                    "type": "row-2-columns-6-6",
                    "uuid": "c07357ff-0bde-45f6-adf3-d3468bf55ec6"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "45px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "b3a46a12-f286-4ab4-8a0f-598acf5acf87"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "aa6bc113-78c7-4f04-a93e-fb23a58207ae"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-1-columns-12",
                    "uuid": "687d2acd-d7ee-4b31-8ade-9b0c46a19a05"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "45px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "58f3e749-58fc-4968-97a1-ce2a68244fba"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><strong><span>" + t("page-default-content-title") + "</span></strong></p>",
                                            "style": {
                                                "color": "#ffffff",
                                                "font-family": "inherit",
                                                "font-size": "34px",
                                                "line-height": "150%",
                                                "text-align": "center"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "20px",
                                            "padding-left": "40px",
                                            "padding-right": "40px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "476da2e2-b7d4-4fad-803d-c105411e7a65"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0068A5"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span>" + t("page-default-content-description") + "</span></p>",
                                            "style": {
                                                "color": "#e7e7e7",
                                                "font-family": "inherit",
                                                "font-size": "20px",
                                                "line-height": "180%",
                                                "text-align": "center"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "45px",
                                            "padding-right": "45px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "a6846068-d96e-43ca-9aec-3491de15ca2f"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"\" data-mce-style=\"\"><p style=\"word-break:break-word;\" data-mce-style=\"word-break:break-word;\"><strong>" + t("page-default-button-label") + "</strong></p></div>",
                                            "style": {
                                                "background-color": "#ffffff",
                                                "border-bottom": "0px solid transparent",
                                                "border-left": "0px solid transparent",
                                                "border-radius": "4px",
                                                "border-right": "0px solid transparent",
                                                "border-top": "0px solid transparent",
                                                "color": "#bf8abf",
                                                "direction": "ltr",
                                                "font-family": "inherit",
                                                "font-size": "16px",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "50px",
                                                "padding-right": "50px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            },
                                            "target": "_self"
                                        },
                                        "computedStyle": {
                                            "height": 42,
                                            "hideContentOnMobile": false,
                                            "width": 189
                                        },
                                        "style": {
                                            "padding-bottom": "30px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "f38f5b53-cdb2-47a2-bdac-41dab4013957"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "25px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "bef56ddd-3021-40f8-a5bd-50b1348f406a"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth fullwidthOnMobile",
                                            "width": "504px"
                                        },
                                        "image": {
                                            "alt": "Alternate text",
                                            "height": "1024px",
                                            "href": "",
                                            "prefix": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2476/Book_last_image.png",
                                            "target": "_self",
                                            "width": "945px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "f9ade019-0515-4761-a8e6-8373a9a0e0aa"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#ffffff"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><u><span><strong><span>www.yourwebsite.com</span></strong></span></u></p>",
                                            "style": {
                                                "color": "#ffffff",
                                                "font-family": "inherit",
                                                "font-size": "26px",
                                                "line-height": "150%",
                                                "text-align": "center"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "20px",
                                            "padding-left": "40px",
                                            "padding-right": "40px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "fe6fe92e-6504-4cef-a1d9-650750c622b8"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "height": 57,
                                            "hideContentOnMobile": false,
                                            "iconsDefaultWidth": 32,
                                            "padding": "0 5px 0 5px",
                                            "width": 151
                                        },
                                        "iconsList": {
                                            "icons": [
                                                {
                                                    "image": {
                                                        "alt": "Facebook",
                                                        "href": "https://www.facebook.com",
                                                        "prefix": "https://www.facebook.com",
                                                        "src": "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-only-logo-white/facebook@2x.png",
                                                        "target": "_self",
                                                        "title": "Facebook"
                                                    },
                                                    "name": "Facebook",
                                                    "text": "",
                                                    "type": "follow"
                                                },
                                                {
                                                    "image": {
                                                        "alt": "Twitter",
                                                        "href": "https://www.twitter.com",
                                                        "prefix": "https://www.twitter.com",
                                                        "src": "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-only-logo-white/twitter@2x.png",
                                                        "target": "_self",
                                                        "title": "Twitter"
                                                    },
                                                    "name": "Twitter",
                                                    "text": "",
                                                    "type": "follow"
                                                },
                                                {
                                                    "image": {
                                                        "alt": "Instagram",
                                                        "href": "https://www.instagram.com",
                                                        "prefix": "https://www.instagram.com",
                                                        "src": "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-only-logo-white/instagram@2x.png",
                                                        "target": "_self",
                                                        "title": "Instagram"
                                                    },
                                                    "name": "Instagram",
                                                    "text": "",
                                                    "type": "follow"
                                                },
                                                {
                                                    "image": {
                                                        "alt": "LinkedIn",
                                                        "href": "https://www.linkedin.com",
                                                        "prefix": "https://www.linkedin.com",
                                                        "src": "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-only-logo-white/linkedin@2x.png",
                                                        "target": "_self",
                                                        "title": "LinkedIn"
                                                    },
                                                    "name": "LinkedIn",
                                                    "text": "",
                                                    "type": "follow"
                                                }
                                            ]
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-social",
                                    "uuid": "6af7d278-3950-4ec8-a822-0f91e58398d9"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "align": "center",
                                                "linkColor": "#C0C0C0"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span style=\"color:#ffffff;\">" + t("page-default-content-description") + "</span></p>",
                                            "style": {
                                                "color": "#ffffff",
                                                "font-family": "inherit",
                                                "font-size": "15px",
                                                "line-height": "150%",
                                                "size": 12,
                                                "text-align": "center"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "a919c819-d494-43db-9143-3133f080f0aa"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "0px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "524f036e-5db9-45b3-99f1-06abec160048"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "0e428397-9d1c-4b65-9247-746e0aef0234"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#bf8abf",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "#bf8abf",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "row-1-columns-12",
                    "uuid": "09749b6f-0ee6-47dc-8b4c-871f5fd85cf9"
                }
            ],
            "template": {
                "name": "template-base",
                "type": "basic",
                "version": "2.0.0"
            },
            "title": ""
        }
    }
}